import $http from './xhr.base'
import qs from 'qs'

let api = {
  //登录系统
  login: function(data, success) {
    $http.post('/account/login.ds', data, {
      transformRequest: [function(data, headers) {
        return qs.stringify(data)
      }]
    }, success)
  },
  //用户退出
  logout: function(data, success) {
    $http.post('/account/logout.ds', data, {}, success)
  },
  //获取当前登录用户信息
  getUserInfo: function(params, success) {
    $http.get('/i/auth/UserInfo.ds', {params}, success)
  },
  //查询商户配置参数
  getMerchantConfig: function(params, success) {
    $http.get('/i/config/MerchantPreference.List.ds', {params}, success)
  },
  //更新商户配置参数
  updateMerchantConfig: function(data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/config/MerchantPreference.ds', data, config, success)
  },
  //查询部门列表
  getConfigDepartmentList: function(params, success) {
    $http.get('/i/config/Department.List.ds', {params}, success)
  },
  //查询部门树结构
  getConfigDepartmentAsTree: function(params, success) {
    $http.get('/i/config/DepartmentAsTree.ds', {params}, success)
  },
  //新增或编辑部门
  updateDepartment: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/config/Department.ds', data, config, success)
  },
  //删除部门
  deleteConfigDepartment: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/config/DeleteDepartment.ds', data, config, success)
  },
  //查询用户列表
  getUserList: function(params, success) {
    $http.get('/i/auth/User.List.ds', {params}, success)
  },
  //查询指定用户
  getUser: function(params, success) {
    $http.get('/i/auth/User.ds', {params}, success)
  },
  //更新新增用户
  updateUser: function(data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/update/auth/User.ds', data, config, success)
  },
  //删除用户
  deleteUser: function(data, success) {
    $http.post('/i/execute/auth/DeleteUser.ds', data, {}, success)
  },
  //启用用户
  enableUser: function(data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/auth/EnableUser.ds', data, config, success)
  },
  //禁用用户
  disableUser: function(data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/auth/DisableUser.ds', data, config, success)
  },
  //重置用户密码
  resetPassword: function(data, success) {
    $http.post('/i/execute/auth/ResetPassword.ds', data, {}, success)
  },
  //修改用户密码
  changePassword: function(data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/auth/ChangePassword.ds', data, config, success)
  },

  //查询登录用户可用的菜单
  getUserMenuList: function(params, success) {
    $http.get('/i/auth/UserMenu.ds', {params}, success)
  },
  //查询登录用户可用的功能
  getUserFunctionList: function(params, success) {
    $http.get('/i/auth/UserFunction.List.ds', {params}, success)
  },
  //查询角色列表
  getRoleList: function(params, success) {
    $http.get('/i/auth/Role.List.ds', {params}, success)
  },
  //更新新增角色
  updateRole: function(data, success) {
    $http.post('/i/execute/auth/Role.ds', data, {}, success)
  },
  //更新绑定角色菜单
  updateRoleMenu: function(data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/auth/RoleMenu.ds', data, config, success)
  },
  //删除角色
  deleteRole: function(data, success) {
    $http.post('/i/execute/auth/DeleteRole.ds', data, {}, success)
  },
  //查询指定角色及所有菜单
  getRoleMenu: function(params, success) {
    $http.get('/i/auth/RoleMenu.ds', {params}, success)
  },
  //查询所有已启用的菜单
  getMenuSelector: function(params, success) {
    $http.get('/i/auth/MenuSelector.ds', {params}, success)
  },
  //查询指定角色的功能
  getRoleFunction: function(params, success) {
    $http.get('/i/auth/RoleFunction.List.ds', {params}, success)
  },
  //更新角色功能
  updateRoleFunction: function(data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/auth/RoleFunction.ds', data, config, success)
  },
  //查询商品列表
  getProductItemList: function(params, success) {
    $http.get('/i/catalog/Item.List.ds', {params}, success)
  },
  //查询指定的统计数据，用于用户首页、功能模块首页的数据显示。
  getReportingStatistics: function(params, success) {
    $http.get('/i/reporting/statistics/Values.ds', {params}, success)
  },

    getFinancingByProduct: function(params, success) {
        $http.get('/i/fang/financing/reporting/FinancingByProduct.List.ds', {params}, success)
    },
  //查询最近30天还款笔数，提款笔数，放款笔数
  getReportingRepaymentPaymentFinancingCountLast30Days: function(params, success) {
    $http.get('/i/multi/ds/reporting/statistics/RepaymentCountLast30Days.List,reporting/statistics/PaymentCountLast30Days.List,reporting/statistics/FinancingCountLast30Days.List.ds', {params}, success)
  },

  //查询金融机构自己的银行账号
  getBankAccountList: function(params, success) {
    $http.get('/i/config/BankAccount.List.ds', {params}, success)
  },
  //更新新增金融机构的银行账号
  updateBankAccount: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/config/BankAccount.ds', data, config, success)
  },
  //删除金融机构的银行账号
  deleteBankAccount: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/config/DeleteBankAccount.ds', data, config, success)
  },

  //查询金融产品
  getFinanceProductList: function (params, success) {
    $http.get('/i/product/Product.List.ds', {params},success)
  },
  //查询金融产品详情
  getFinanceProductDetail: function (params, success) {
    $http.get('/i/product/Product.ds', {params}, success)
  },
  //更新新增金融产品
  updateFinanceProduct: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/product/Product.ds', data, config, success)
  },
  //删除金融产品
  deleteFinanceProduct: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/product/DeleteProduct.ds', data, config, success)
  },
  //查询核心企业列表
  getDebtorList: function (params, success) {
    $http.get('/i/customer/Debtor.List.ds', {params}, success)
  },
  //新增修改核心企业
  updateDebtor: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/customer/Debtor.ds', data, config, success)
  },
  //删除核心企业
  deleteDebtor: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/customer/DeleteDebtor.ds', data, config, success)
  },
  //查询核心企业详情
  getDebtorDetail: function (params, success) {
    $http.get('/i/customer/Debtor.ds', {params}, success)
  },
  //查询核心企业用户列表
  getDebtorUserList: function(params, success) {
    $http.get('/i/customer/DebtorUser.List.ds', {params}, success)
  },
  //查询核心企业用户详情
  getDebtorUserDetail: function (params, success) {
    $http.get('/i/customer/DebtorUser.ds', {params}, success)
  },
  //更新新增核心企业用户
  updateDebtorUser: function(data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/customer/DebtorUser.ds', data, config, success )
  },
  //查询客户列表
  getCustomerList: function (params, success) {
    $http.get('/i/customer/Customer.List.ds', {params}, success)
  },

  //查询客户详情
  getCustomerDetail: function (params, success) {
    $http.get('/i/customer/Customer.ds', {params}, success)
  },
  //客户纵览
  getCustomerSummary: function (params, success) {
    $http.get('/i/customer/CustomerSummary.ds', {params}, success)
  },
  //更新客户详情
  updateCustomerDetail: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/customer/Customer.ds', data, config, success)
  },
  //查询客户申请列表
  getApplyingCustomerList: function (params, success) {
    $http.get('/i/customer/ApplyingCustomer.List.ds', {params}, success)
  },
  //查询客户申请详情
  getApplyingCustomerDetail: function (params, success) {
    $http.get('/i/customer/ApplyingCustomer.ds', {params}, success)
  },
  //查询客户申请审核详情列表
  getCustomerApprovalList: function(params, success) {
    $http.get('/i/auth/Approval.List.ds', {params}, success)
  },
  //获取申请上传文件
  getApplyingCustomerCreditAttachment:function (params, success) {
    $http.get('/i/customer/ApplyingCustomerCreditAttachment.ds', {params}, success)
  },
  //查询客户审核列表
  getApplyingVehicleMortgageCustomerList: function (params, success) {
    $http.get('/i/customer/ApplyingVehicleMortgage.List.ds', {params}, success)
  },
  //详情
  getApplyingVehicleMortgageCustomerDetail: function (params, success) {
    $http.get('/i/customer/ApplyingVehicleMortgage.ds', {params}, success)
  },

  //更新审核客户申请
  updateApproveVehicleMortgageCustomer: function (data,success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/customer/BeforeApproveVehicleMortgage.ds', data, config, success )
  },


  //查询客户用户列表
  getCustomerUserList: function(params, success) {
    $http.get('/i/customer/CustomerUser.List.ds', {params}, success)
  },
  //查询客户用户详情
  getCustomerUserDetail: function (params, success) {
    $http.get('/i/customer/CustomerUser.ds', {params}, success)
  },
  //更新新增客户账号
  updateCustomerUser: function(data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/customer/CustomerUser.ds', data, config, success )
  },
  //更新审核客户申请
  updateApproveCustomer: function (data,success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/customer/BeforeApproveCustomer.ds', data, config, success )
  },

  updateApproveCustomerEdit: function (data,success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/customer/BeforeApproveCustomerEdit.ds', data, config, success )
  },

  //查询客户的银行账户
  getCustomerBankAccountList: function(params, success) {
    $http.get('/i/customer/CustomerBankAccount.List.ds', {params}, success)
  },
  getDebtorBankAccountList: function(params, success) {
    $http.get('/i/customer/DebtorBankAccount.List.ds', {params}, success)
  },
  //新增编辑客户的银行账户
  updateCustomerBankAccount: function(data, success) {
    let config = {
      showMessage: true
    }

    $http.post('/i/execute/customer/CustomerBankAccount.ds', data, config, success)
  },
  //删除客户的银行账户
  deleteCustomerBankAccount: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/customer/DeleteCustomerBankAccount.ds', data, config, success)
  },

  //查询客户授信列表
  getCustomerCreditList: function (params, success) {
    $http.get('/i/customer/CustomerCredit.List.ds', {params}, success)
  },
  //查询客户授信详情
  getCustomerCreditDetail: function (params, success) {
    $http.get('/i/customer/CustomerCredit.ds', {params}, success)
  },

  //查询客户授信申请详情
  getApplyCustomerCreditDetail: function (params, success) {
    $http.get('/i/customer/ApplyCustomerCredit.ds', {params}, success)
  },
  //录入客户授信
  updateCustomerCredit: function(data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/customer/CustomerCredit.ds', data, config, success )
  },
  //查询客户合同申请列表
  getCustomerApplyingContractList: function (params, success) {
    $http.get('/i/customer/ApplyingContract.List.ds', {params}, success)
  },
  //查询客户合同申请详情
  getCustomerApplyingContractDetail: function (params, success) {
    $http.get('/i/customer/ApplyingContract.ds', {params}, success)
  },
  //更新新增审核客户合同
  updateCustomerApproveContract: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/customer/ApproveContract.ds', data, config, success )
  },
  //查询客户合同列表
  getCustomerContractList: function (params, success) {
    $http.get('/i/customer/Contract.List.ds', {params}, success)
  },
  //查询客户合同详情
  getCustomerContractDetail: function (params, success) {
    $http.get('/i/customer/Contract.ds', {params}, success)
  },
  //查询客户质押申请列表
  getCustomerApplyingPledgeList: function (params, success) {
    $http.get('/i/pledge/ApplyingPledge.List.ds', {params}, success)
  },
  //查询客户质押申请详情
  getCustomerApplyingPledgeDetail: function (params, success) {
    $http.get('/i/pledge/ApplyingPledge.ds', {params}, success)
  },
  //审核客户质押申请
  updateCustomerApplyingPledge: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/pledge/ApprovePledge.ds', data, config, success)
  },
  //查询客户质押列表
  getCustomerPledgeList: function (params, success) {
    $http.get('/i/pledge/Pledge.List.ds', {params}, success)
  },
  //查询客户质押详情
  getCustomerPledgeDetail: function (params, success) {
    $http.get('/i/pledge/Pledge.ds', {params}, success)
  },
  //查询客户单据列表
  getCustomerInvoiceList: function (params, success) {
    $http.get('/i/customer/Invoice.List.ds', {params}, success)
  },
  //查询客户融资申请列表
  getCustomerApplyingFinancingList: function (params, success) {
    $http.get('/i/financing/ApplyingFinancing.List.ds', {params}, success)
  },
  //查询客户融资申请详情
  getCustomerApplyingFinancingDetail: function (params, success) {
    $http.get('/i/financing/ApplyingFinancing.ds', {params}, success)
  },
  //放款
  payFinancing: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/financing/PayFinancing.ds', data, config, success)
  },
  //查询还款计划
  getCustomerRepaymentPlanList: function (params, success) {
    $http.get('/i/financing/RepaymentPlan.List.ds', {params}, success)
  },
  //查询实际还款情况
  getCustomerRepaymentExecutionList: function (params, success) {
    $http.get('/i/financing/RepaymentExecution.List.ds', {params}, success)
  },
  //查询新一期还款要求
  getRepayPledgeFinancing: function (params, success) {
    $http.get('/i/financing/RepayPledgeFinancing.ds', {params}, success)
  },
  //还款
  updateRepayPledgeFinancing: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/financing/RepayPledgeFinancing.ds', data, config, success)
  },
  //线下人工还款
  updateFinancingRepayOffline: function(data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/financing/RepayOffline.ds', data, config, success)
  },

  //查询放款列表
  getCustomerPaymentList: function (params, success) {
    $http.get('/i/financing/Payment.List.ds', {params}, success)
  },

  //查询客户还款列表
  getCustomerRepaymentList: function (params, success) {
    $http.get('/i/financing/Repayment.List.ds', {params}, success)
  },
  //查询客户资金流水记录
  getCustomerCashJournalList: function(params, success) {
    $http.get('/i/financing/CashJournal.List.ds', {params}, success)
  },

  //发送手机验证码
  sendMobileCode: function (params, success) {
    $http.get('/account/token/mobile/'+params.mobileNo+'.do', {params}, success)
  },
  //验证手机码
  checkMobileCode: function (data, success) {
    $http.post('/account/reg/check.do', data, {
      transformRequest: [function(data, headers) {
        return qs.stringify(data)
      }]
    }, success)
  },
  //提交会员注册申请
  createAccount: function (data, success) {
    let config = {
      showMessage: false
    }
    $http.post('/account/reg/create.do', data, config, success)
  },
  getReportingOverdueList: function(params, success) {
    $http.get('/i/reporting/Overdue.List.ds', {params}, success)
  },

  getReportingFinanceList: function(params, success) {
    $http.get('/i/reporting/Financing.List.ds', {params}, success)
  },
  getFinancingOutstandingList: function(params, success) {
    $http.get('/i/financing/Outstanding.List.ds', {params}, success)
  },
  //查询客户端授信列表
  getCreditList: function (params, success) {
    $http.get('/i/capi/credit/CustomerCredit.List.ds', {params}, success)
  },
  //查询客户端授信详情
  getCreditDetail: function (params, success) {
    $http.get('/i/capi/credit/CustomerCredit.ds', {params}, success)
  },
  //查询客户融资申请列表
  getCustomerApplyingPledgeFinancing: function (params, success) {
    $http.get('/i/financing/ApplyingPledgeFinancing.List.ds', {params}, success)
  },
  //查询客户融资申请详情
  getCustomerApplyingPledgeFinancingDetail: function (params, success) {
    $http.get('/i/financing/ApplyingPledgeFinancing.ds', {params}, success)
  },
  //审核客户融资申请
  updateCustomerApplyingFinancing: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/financing/ApproveFinancing.ds', data, config, success)
  },
  //查询客户融资列表
  getCustomerFinancingList: function (params, success) {
    $http.get('/i/financing/Financing.List.ds', {params}, success)
  },
  //查询客户融资详情
  getCustomerFinancingDetail: function (params, success) {
    $http.get('/i/financing/Financing.ds', {params}, success)
  },
  //获取贷前风控
  getCustomerTongdun: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/customer/CustomerTongdun.ds', data, config, success)
  },
  getTongDun: function (params, success) {
    $http.get('/i/customer/CustomerTongdun.ds', {params}, success)
  },

  getTongDunList: function (params, success) {
    $http.get('/i/customer/TongDun.List.ds', {params}, success)
  },
  //更新提交合同申请
  updateApplyContract: function(data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/capi/contract/ApplyContract.ds', data, config, success)
  },
  //查询合同申请列表
  getApplyingContractList: function (params, success) {
    $http.get('/i/capi/contract/ApplyingContract.List.ds', {params}, success)
  },
  //查询合同申请详情
  getApplyingContractDetail: function (params, success) {
    $http.get('/i/capi/contract/ApplyingContract.ds', {params}, success)
  },
  //查询我的合同记录
  getContractList: function (params, success) {
    $http.get('/i/capi/contract/Contract.List.ds', {params}, success)
  },
  //查询我的合同详情
  getContractDetail: function (params, success) {
    $http.get('/i/capi/contract/Contract.ds', {params}, success)
  },
  //更新新增质押
  updateApplyPledge: function(data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/capi/pledge/ApplyPledge.ds', data, config, success)
  },
  //查询应收账款申请列表
  getApplyingPledgeList: function (params, success) {
    $http.get('/i/capi/pledge/ApplyingPledge.List.ds', {params}, success)
  },
  //查询应收账款申请详情
  getApplyingPledgeDetail: function (params, success) {
    $http.get('/i/capi/pledge/ApplyingPledge.ds', {params}, success)
  },
  //查询我的应收账款登记记录
  getPledgeList: function (params, success) {
    $http.get('/i/capi/pledge/Pledge.List.ds', {params}, success)
  },
  //查询应收账款记录详情
  getPledgeDetail: function (params, success) {
    $http.get('/i/capi/pledge/Pledge.ds', {params}, success)
  },
  //查询应收财款记录
  getPledgeInvoiceList: function(params, success) {
    $http.get('/i/capi/pledge/PledgeInvoice.List.ds', {params}, success)
  },
  //新增保存融资
  updateApplyPledgeFinancing: function(data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/capi/financing/ApplyPledgeFinancing.ds', data, config, success)

  },
  //查询融资申请列表
  getApplyingPledgeFinancing: function (params, success) {
    $http.get('/i/capi/financing/ApplyingPledgeFinancing.List.ds', {params}, success)
  },
  //查询融资申请详情
  getApplyingPledgeFinancingDetail: function (params, success) {
    $http.get('/i/capi/financing/ApplyingPledgeFinancing.ds', {params}, success)
  },
  //查询融资列表
  getFinancingList: function (params, success) {
    $http.get('/i/capi/financing/PledgeFinancing.List.ds', {params}, success)
  },
  //查询融资详情
  getFinancingDetail: function (params, success) {
    $http.get('/i/capi/financing/PledgeFinancing.ds', {params}, success)
  },
  //查询还款计划表
  getRepaymentPlanList: function (params, success) {
    $http.get('/i/capi/financing/RepaymentPlan.List.ds', {params}, success)
  },
  //查询实际还款表
  getRepaymentExecutionList: function (params, success) {
    $http.get('/i/capi/financing/RepaymentExecution.List.ds', {params}, success)
  },
  //查询自己的还款记录
  getRepaymentList: function (params, success) {
    $http.get('/i/capi/financing/CustomerRepayment.List.ds', {params}, success)

  },

  //查询客户自己的银行账号
  getBankAccount: function (params, success) {
    $http.get('/i/capi/common/CustomerBankAccount.Select.ds', {params}, success)
  },

  getDealerList: function (params, success) {
    $http.get('/i/fang/dealer/Dealer.List.ds', {params}, success)
  },
  getDealerType: function (params, success) {
    $http.get('/i/fang/dealer/DealerType.Select.ds', {params}, success)
  },
  updateDealer: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/update/fang/dealer/Dealer.ds', data, config, success)
  },
  getDealer: function (params, success) {
    $http.get('/i/fang/dealer/Dealer.ds', {params}, success)
  },
  getDealerUserList :function (params, success) {
    $http.get('/i/fang/dealer/DealerUser.List.ds', {params}, success)
  },
  getDealerProductList :function (params, success) {
    $http.get('/i/fang/dealer/DealerProduct.ds', {params}, success)
  },
  /*deleteDealer: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/dealer/DeleteDealer.ds', data, config, success)
  },*/
  updateDealerUser: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/update/fang/dealer/DealerUser.ds', data, config, success)
  },
  updateDealerProduct: function (data, success) {
    let config = {
      showMessage: false
    }
    $http.post('/i/update/fang/dealer/DealerProduct.ds', data, config, success)
  },
  getDealerUser: function (params, success) {
    $http.get('/i/fang/dealer/DealerUser.ds', {params}, success)
  },
  getApplyingCustomerFangList :function (params, success) {
    $http.get('/i/fang/financing/ApplyingCustomer.List.ds', {params}, success)
  },
    getMatureBeforeNextMonthList :function (params, success) {
        $http.get('/i/fang/financing/reporting/MatureBeforeNextMonth.List.ds', {params}, success)
    },

  getApplyingCustomerFang :function (params, success) {
      $http.get('/i/fang/financing/ViewApplyingCustomer.ds', {params}, success)
  },

  updateApproveCustomerFangEdit: function (data,success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/update/fang/financing/ApproveCustomer.ds', data, config, success )
  },
  AddApplyingCustomerInfo: function (data,success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/update/fang/financing/AddApplyingCustomerInfo.ds', data, config, success )
  },
  getCustomerFangList :function (params, success) {
    $http.get('/i/fang/financing/ApplyingCustomer.List.ds', {params}, success)
  },
  getFinancingFangList :function (params, success) {
    $http.get('/i/fang/financing/Financing.List.ds', {params}, success)
  },
  getCustomerCreateFang :function (params, success) {
    $http.get('/i/fang/financing/CreateFinancing.ds', {params}, success)
  },
  updateCreateFinancing :function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/financing/CreateFinancing.ds', data, config, success )
  },
  getFinanceProductFangList: function (params, success) {
    $http.get('/i/fang/financing/DealerProduct.List.ds', {params},success)
  },

    getAdministrativeRegion: function (params, success) {
        $http.get('/i/fang/misc/AdministrativeRegion.Select.ds', {params},success)
    },

  getFinancingFang :function (params, success) {
    $http.get('/i/fang/financing/ViewFinancing.ds', {params}, success)
  },

  voidApplyingCustomer:function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/financing/VoidApplyingCustomer.ds', data, config, success )
  },

  voidFinancing:function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/financing/VoidFinancing.ds', data, config, success )
  },
  updateApproveFinancing:function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/financing/ApproveFinancing.ds', data, config, success )
  },
//日均贷款余额表
  getOutstandingDaily: function (params, success) {
    $http.get('/i/fang/financing/reporting/OutstandingDaily.List.ds', {params},success)
  },
  //日均贷款余额表2
  getOutstandingDaily2: function (params, success) {
    $http.get('/i/fang/financing/reporting/OutstandingDaily.Since202006.List.ds', {params},success)
  },
    getOutstandingDaily2021: function (params, success) {
        $http.get('/i/fang/financing/lender/reporting/OutstandingDaily.Since202106.List.ds', {params},success)
    },

  getOutstandingMonthly2: function (params, success) {
    $http.get('/i/fang/financing/reporting/OutstandingMonthly.Since202006.List.ds', {params},success)
  },
    //日均助贷余额表
    getOutstandingMonthly2021: function (params, success) {
        $http.get('/i/fang/financing/lender/reporting/OutstandingMonthly.Since202106.List.ds', {params},success)
    },
  //按月每日贷款余额明细
  getOutstandingMonthly: function (params, success) {
    $http.get('/i/fang/financing/reporting/OutstandingMonthly.List.ds', {params},success)
  },
  updateOutstandingMonthly:function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/financing/reporting/UpdateOutstandingMonthly.ds', data, config, success )
  },

    updateOutstandingMonthly2021:function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/execute/fang/financing/lender/reporting/UpdateOutstandingMonthly.ds', data, config, success )
    },



    //贷款余额明细
  getOutstandingDetail: function (params, success) {
    $http.get('/i/fang/financing/reporting/OutstandingDetail.List.ds', {params},success)
  },

  //贷款余额明细
  getOutstandingDetai2: function (params, success) {
    $http.get('/i/fang/financing/reporting/OutstandingDetail.Since202006.List.ds', {params},success)
  },
    getOutstandingDetai2021: function (params, success) {
        $http.get('/i/fang/financing/lender/reporting/OutstandingDetail.Since202106.List.ds', {params},success)
    },
    getCustomerBankAccountFangList: function(params, success) {
    $http.get('/i/fang/financing/CustomerBankAccount.Select.ds', {params}, success)
  },
  //查询客户列表
  getFangCustomerList: function (params, success) {
    $http.get('/i/fang/customer/Customer.List.ds', {params}, success)
  },
  //查询客户列表
  getFangCustomer: function (params, success) {
    $http.get('/i/fang/customer/Customer.ds', {params}, success)
  },
//放款
  updatePayFinancing:function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/financing/PayFinancing.ds', data, config, success )
  },

  //待还款列表
  getOutstanding: function(params, success) {
    $http.get('/i/fang/financing/Outstanding.List.ds', {params}, success)
  },
  //
  getRepayPlan: function(params, success) {
    $http.get('/i/fang/financing/ViewOutstanding.ds', {params}, success)
  },
  getRepayPlanAll: function(params, success) {
    $http.get('/i/fang/financing/ViewRepaymentPlan.ds', {params}, success)
  },
//还款记录查询
  getFinancingRepaymentList: function(params, success) {
    $http.get('/i/fang/financing/Repayment.List.ds', {params}, success)
  },
  //
  updateRepayPlan:function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/financing/RepayOffline.ds', data, config, success )
  },
  getFangReportingOverdueList: function(params, success) {
    $http.get('/i/fang/financing/reporting/Overdue.List.ds', {params}, success)
  },
  getFangReportingFinanceList: function(params, success) {
    $http.get('/i/fang/financing/reporting/Rebate.List.ds', {params}, success)
  },

  getPropertyLocationList: function (params, success) {
    $http.get('/i/fang/dw/PropertyLocation.List.ds', {params}, success)
  },

  //新增或编辑部门
  updateBank: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/update/fang/customer/CustomerBankAccount.ds', data, config, success)
  },
  updateBank2: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/financing/FinancingBankAccount.ds', data, config, success)
  },
  //
  getFinancingBankAccount: function (params, success) {
    $http.get('/i/fang/financing/FinancingBankAccount.List.ds', {params}, success)
  },
//导入银行流水
  uploadBankStatement: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/update/fang/repayment/UploadBankStatement.ds', data, config, success)
  },
//
  getResolvingBankStatementList: function (params, success) {
    $http.get('/i/fang/repayment/ResolvingBankStatement.List.ds', {params}, success)
  },
  getResolvingBankStatementDetailList: function (params, success) {
    $http.get('/i/fang/repayment/ResolvingBankStatementDetail.List.ds', {params}, success)
  },

  getSettledBankStatementList: function (params, success) {
    $http.get('/i/fang/repayment/SettledBankStatement.List.ds', {params}, success)
  },
  getSettledBankStatementDetailList: function (params, success) {
    $http.get('/i/fang/repayment/SettledBankStatementDetail.List.ds', {params}, success)
  },

  getOutstandingList: function (params, success) {
    $http.get('/i/fang/repayment/Outstanding.Select.ds', {params}, success)
  },

  updateOutstanding: function (data, success) {
  let config = {
    showMessage: true
  }
  $http.post('/i/update/fang/repayment/Resolve.ds', data, config, success)
  },
  getRepayInfo: function (params, success) {
    $http.get('/i/fang/repayment/RepayInfo.ds', {params}, success)
  },
  updateRepayForApproval:function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/repayment/RepayForApproval.ds', data, config, success )
  },
  deleteVoidBankStatementDetail:function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/repayment/VoidBankStatementDetail.ds', data, config, success )
  },
  updateRepayInBatch:function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/repayment/RepayInBatch.ds', data, config, success )
  },
    RepayNext:function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/execute/fang/repayment/RepayNext.ds', data, config, success )
    },
  getRepayInBatch: function (params, success) {
    $http.get('/i/fang/repayment/RepayInBatch.ds', {params}, success)
  },

  getApplyingRepayment: function (params, success) {
    $http.get('/i/fang/repayment/ApplyingRepayment.List.ds', {params}, success)
  },

  getSplittable: function (params, success) {
    $http.get('/i/fang/repayment/SplitInfo.ds', {params}, success)
  },

  updateSplittable:function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/repayment/Split.ds', data, config, success )
  },
  splittableUpdate:function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/repayment/VoidSplit.ds', data, config, success )
  },

  deleteVoidResolve:function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/repayment/VoidResolve.ds', data, config, success )
  },
  getViewRepayForApproval: function (params, success) {
    $http.get('/i/fang/repayment/ViewRepayForApproval.ds', {params}, success)
  },
  updateApproveRepayment:function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/repayment/ApproveRepayment.ds', data, config, success )
  },
  getRepayOfflineInfo: function (params, success) {
    $http.get('/i/fang/repayment/RepayOfflineInfo.ds', {params}, success)
  },
  getAddNotes: function (params, success) {
    $http.get('/i/fang/repayment/AddNotes.ds', {params}, success)
  },
  updateAddNotes:function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/repayment/AddNotes.ds', data, config, success )
  },
  getRepaymentStatsList: function (params, success) {
    $http.get('/i/fang/financing/reporting/RepaymentStats.List.ds', {params}, success)
  },
    getRepaymentPlanFangList: function (params, success) {
        $http.get('/i/fang/financing/lender/reporting/RepaymentPlan.List.ds', {params}, success)
    },
  getApplyingRepaymentInAdvanceList: function (params, success) {
    $http.get('/i/fang/repayment/ApplyingRepaymentInAdvance.List.ds', {params}, success)
  },
  getProcessingFinancingSelect: function (params, success) {
    $http.get('/i/fang/repayment/ProcessingFinancing.Select.ds', {params}, success)
  },
  getRevisedRepaymentPlan: function (params, success) {
    $http.get('/i/fang/repayment/RevisedRepaymentPlan.ds', {params}, success)
  },
  getApproveRepaymentInAdvance: function (params, success) {
    $http.get('/i/fang/repayment/ViewRepayInAdvanceForApproval.ds', {params}, success)
  },
  updateRevisedRepaymentPlan:function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/repayment/RevisedRepaymentPlan.ds', data, config, success )
  },
  getBankStatementList: function (params, success) {
    $http.get('/i/fang/repayment/BankStatement.List.ds', {params}, success)
  },
  updateApproveRepaymentInAdvance:function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/repayment/ApproveRepaymentInAdvance.ds', data, config, success )
  },
  getBankStatementSummaryList: function (params, success) {
    $http.get('/i/fang/repayment/reporting/BankStatementSummary.List.ds', {params}, success)
  },

  getBankStatementUseList: function (params, success) {
    $http.get('/i/fang/repayment/reporting/BankStatementUse.List.ds', {params}, success)
  },
  getBankStatementUseDetailList: function (params, success) {
    $http.get('/i/fang/repayment/reporting/BankStatementUseDetail.List.ds', {params}, success)
  },
    getRepaymentByCustomerList: function (params, success) {
        $http.get('/i/fang/financing/reporting/RepaymentByCustomer.List.ds', {params}, success)
    },
//首页
  getWelcomeList  : function (params, success) {
    $http.get('/i/fang/dashboard/Welcome.List.ds', {params}, success)
  },
  getFinancingLast12MonthsList: function (params, success) {
    $http.get('/i/fang/financing/reporting/FinancingLast12Months.List.ds', {params}, success)
  },
  getFinancingByDealerList: function (params, success) {
    $http.get('/i/fang/financing/reporting/FinancingByDealer.List.ds', {params}, success)
  },
  getFinancingByFormulaList: function (params, success) {
    $http.get('/i/fang/financing/reporting/FinancingByFormula.List.ds', {params}, success)
  },
//代客进件
  createApplyingCustomerOffline :function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/update/fang/financing/CreateApplyingCustomerOffline.ds', data, config, success )
  },
  //RepaymentExcessAmountList
  getRepaymentExcessAmountList: function (params, success) {
    $http.get('/i/fang/repayment/RepaymentExcessAmount.List.ds', {params}, success)
  },
  UpdateExcessAmountOption:function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/repayment/UpdateExcessAmountOption.ds', data, config, success )
  },
  getRepaymentCollectionList: function (params, success) {
    $http.get('/i/fang/repayment/RepaymentCollection.List.ds', {params}, success)
  },
  getRepaymentCollection: function (params, success) {
    $http.get('/i/fang/repayment/RepaymentCollection.ds', {params}, success)
  },
  RepaymentCollectionConfirmed:function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/repayment/RepaymentCollectionConfirmed.ds', data, config, success )
  },

  createFinancingPaymentForApproval: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/financing/FinancingPaymentForApproval.ds', data, config, success)
  },
  //放款申请列表
  getFinancingPaymentForApprovalList: function (params, success) {
    $http.get('/i/fang/financing/FinancingPaymentForApproval.List.ds', {params}, success)
  },
  //放款申请
  getViewFinancingPaymentForApproval: function (params, success) {
    $http.get('/i/fang/financing/ViewFinancingPaymentForApproval.ds', {params}, success)
  },
  getFinancingReadyForPayment :function (params, success) {
    $http.get('/i/fang/financing/FinancingReadyForPayment.List.ds', {params}, success)
  },

  docs: function (params, success) {
  $http.get('/extended/financing/docs.do', {params, timeout: 10*60*1000}, success)
},

  createApproveFinancingPayment: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/financing/ApproveFinancingPayment.ds', data, config, success)
  },

  getFinancingPaymentForProcessing :function (params, success) {
    $http.get('/i/fang/financing/FinancingPaymentForProcessing.List.ds', {params}, success)
  },
  getViewAllinpayForApproval :function (params, success) {
    $http.get('/i/fang/financing/ViewAllinpayForApproval.ds', {params}, success)
  },
  createAllinpayForApproval: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/financing/AllinpayForApproval.ds', data, config, success)
  },
  createAllinpayApproved: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/financing/AllinpayApproved.ds', data, config, success)
  },
  VoidFinancingPaymentApplication: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/financing/VoidFinancingPaymentApplication.ds', data, config, success)
  },
  sendAllinpaySMS: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/financing/AllinpaySMS.ds', data, config, success)
  },
  getFinancingPaymentList :function (params, success) {
    $http.get('/i/fang/financing/FinancingPayment.List.ds', {params}, success)
  },
  getViewFinancingPayment :function (params, success) {
    $http.get('/i/fang/financing/ViewFinancingPayment.ds', {params}, success)
  },
  GetAccountBalance: function (data, success) {
    let config = {
        showMessage: false,
        showLoading:false
    }
    $http.post('/i/execute/fang/allinpay/GetAccountBalance.ds', data, config, success)
  },
  getAllinpayQueryLogList :function (params, success) {
    $http.get('/i/fang/financing/AllinpayQueryLog.List.ds', {params}, success)
  },
  getViewAllinpayInfo:function (params, success) {
    $http.get('/i/fang/financing/ViewAllinpayInfo.ds', {params}, success)
  },
  updateAllinpayRetry: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/financing/AllinpayRetry.ds', data, config, success)
  },
  //重新发起
  ReInitApplyingCustomer: function (data,success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/execute/fang/financing/ReInitApplyingCustomer.ds', data, config, success )
  },

    //撤回进件
    RevokeApprovingCustomer: function (data,success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/execute/fang/financing/RevokeApprovingCustomer.ds', data, config, success )
    },
    //撤回贷款
    RevokeApprovingFinancing: function (data,success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/execute/fang/financing/RevokeApprovingFinancing.ds', data, config, success )
    },
    //撤回用款
    RevokeApprovingFinancingPayment: function (data,success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/execute/fang/financing/RevokeApprovingFinancingPayment.ds', data, config, success )
    },
    //撤回用款
    RevokeApprovingHisWarrantCheckout: function (data,success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/execute/fang/financing/RevokeApprovingHisWarrantCheckout.ds', data, config, success )
    },
  //放款明细表
  getReportingFinancingPaymentList :function (params, success) {
    $http.get('/i/fang/financing/reporting/FinancingPayment.List.ds', {params}, success)
  },

    getLenderFinancingListList :function (params, success) {
        $http.get('/i/fang/financing/lender/reporting/Financing.List.ds', {params}, success)
    },
  //未结清贷款明细
  getOutstandingToDateList: function (params, success) {
    $http.get('/i/fang/financing/reporting/OutstandingToDate.List.ds', {params}, success)
  },
  //利息收入明细表
  getInterestRevenueList :function (params, success) {
    $http.get('/i/fang/financing/reporting/InterestRevenue.List.ds', {params}, success)
  },

  //1、	缴退保证金列表
  getDepositApplicationForApprovalList: function (params, success) {
    $http.get('/i/fang/deposit/DepositApplicationForApproval.List.ds', {params}, success)
  },
  updateDepositApplication: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/update/fang/deposit/DepositApplicationForApproval.ds', data, config, success)
  },
  getApproveDepositApplication :function (params, success) {
    $http.get('/i/fang/deposit/ApproveDepositApplication.ds', {params}, success)
  },
  getViewDepositApplicationForApproval:function (params, success) {
    $http.get('/i/fang/deposit/ViewDepositApplicationForApproval.ds', {params}, success)
  },
  updateApproveDepositApplication: function (data, success) {
    let config = {
      showMessage: true
    }
    $http.post('/i/update/fang/deposit/ApproveDepositApplication.ds', data, config, success)
  },
  //1、	保证金台账
  getDepositBalanceList: function (params, success) {
    $http.get('/i/fang/deposit/DepositBalance.List.ds', {params}, success)
  },
  //6、	保证金收支明细
  getDepositTxList: function (params, success) {
    $http.get('/i/fang/deposit/DepositTx.List.ds', {params}, success)
  },
  //7、	占用额度明细
  getFinancingWithDepositList: function (params, success) {
    $http.get('/i/fang/deposit/FinancingWithDeposit.List.ds', {params}, success)
  },

    //查询客户列表
    getFinancingRequestList: function (params, success) {
        $http.get('/i/fang/customer/FinancingRequest.List.ds', {params}, success)
    },
    AssignDealerForFinancingRequest: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/execute/fang/customer/AssignDealerForFinancingRequest.ds', data, config, success)
    },
    getFinancingRequest: function (params, success) {
        $http.get('/i/fang/customer/FinancingRequest.ds', {params}, success)
    },
    shisuan2 :function (params, success) {
        $http.get('/i/fang/repayment/RepayCal.ds', {params}, success)
    },

    getLenderList: function (params, success) {
        $http.get('/i/fang/lender/Lender.List.ds', {params}, success)
    },
    updateLender: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/lender/Lender.ds', data, config, success)
    },
    getLender: function (params, success) {
        $http.get('/i/fang/lender/Lender.ds', {params}, success)
    },
    getLenderUserList :function (params, success) {
        $http.get('/i/fang/lender/LenderUser.List.ds', {params}, success)
    },
    updateLenderUser: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/lender/LenderUser.ds', data, config, success)
    },
    getLenderUser: function (params, success) {
        $http.get('/i/fang/lender/LenderUser.ds', {params}, success)
    },
    DeleteLenderUser: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/execute/fang/lender/DeleteLenderUser.ds', data, config, success)
    },
    getAllocationCandidatesList :function (params, success) {
        $http.get('/i/fang/financing/lender/AllocationCandidates.List.ds', {params}, success)
    },
    getLenderSelect :function (params, success) {
        $http.get('/i/fang/financing/lender/Lender.Select.ds', {params}, success)
    },
    Deallocate: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/execute/fang/financing/lender/Deallocate.ds', data, config, success)
    },
    updateAllocate: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/execute/fang/financing/lender/Allocate.ds', data, config, success)
    },

    getLenderApply:function (params, success) {
        $http.get('/i/fang/financing/lender/LenderFinancing.List.ds', {params}, success)
    },
    getViewLenderFinancing: function (params, success) {
        $http.get('/i/fang/financing//lender/ViewLenderFinancing.ds', {params}, success)
    },
    getAllocationList :function (params, success) {
        $http.get('/i/fang/financing/lender/Allocation.List.ds', {params}, success)
    },
    getHisWarrantList:function (params, success) {
        $http.get('/i/fang/financing/HisWarrant.List.ds', {params}, success)
    },
    getFinancingSelect:function (params, success) {
        $http.get('/i/fang/financing/Financing.Select.ds', {params}, success)
    },
    getFinancingForHisWarrantCheckout:function (params, success) {
        $http.get('/i/fang/financing/FinancingForHisWarrantCheckout.List.ds', {params}, success)
    },
    getViewFinancingForHisWarrantCheckout :function (params, success) {
        $http.get('/i/fang/financing/ViewFinancingForHisWarrantCheckout.ds', {params}, success)
    },
    updateHisWarrantCheckout: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/execute/fang/financing/HisWarrantCheckout.ds', data, config, success)
    },
    getHisWarrantTxList:function (params, success) {
        $http.get('/i/fang/financing//HisWarrantTx.List.ds', {params}, success)
    },
    getHisWarrantTx :function (params, success) {
        $http.get('/i/fang/financing/HisWarrantTx.ds', {params}, success)
    },
    updateApproveHisWarrantCheckout: function (data,success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/execute/fang/financing/ApproveHisWarrantCheckout.ds', data, config, success )
    },
    getHisWarrantTxDetail:function (params, success) {
        $http.get('/i/fang/financing/HisWarrantTxDetail.List.ds', {params}, success)
    },
    getProxyPersonList :function (params, success) {
        $http.get('/i/fang/misc/ProxyPerson.List.ds', {params}, success)
    },
    updateProxyPerson: function (data,success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/misc/ProxyPerson.ds', data, config, success )
    },
    getProxyPerson:function (params, success) {
        $http.get('/i/fang/misc/ProxyPerson.ds', {params}, success)
    },
    getIndustry: function (params, success) {
        $http.get('/i/fang/misc/Industry.Select.ds', {params}, success)
    },
    getWarrant :function (params, success) {
        $http.get('/i/fang/financing/Warrant.Select.ds', {params}, success)
    },
    getBusinessPartnerList: function (params, success) {
        $http.get('/i/fang/misc/BusinessPartner.List.ds', {params}, success)
    },
    getBusinessPartner :function (params, success) {
        $http.get('/i/fang/misc/BusinessPartner.ds', {params}, success)
    },
    updateBusinessPartner: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/misc/BusinessPartner.ds', data, config, success)
    },


    getEquitySwapPartnerList: function (params, success) {
        $http.get('/i/fang/misc/EquitySwapPartner.List.ds', {params}, success)
    },
    deleteEquitySwapPartner: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/misc/DeleteEquitySwapPartner.ds', data, config, success)
    },

    getEquitySwapPartner: function (params, success) {
        $http.get('/i/fang/misc/EquitySwapPartner.ds', {params}, success)
    },
    updateEquitySwapPartner: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/misc/EquitySwapPartner.ds', data, config, success)
    },
    getPartnerOptions: function (params, success) {
        $http.get('/i/fang/misc/EquitySwapPartner.Select.ds', {params}, success)
    },
    getEquitySwapCandidatesSelect: function (params, success) {
        $http.get('/i/fang/misc/EquitySwapCandidates.Select.ds', {params}, success)
    },
    updateEquitySwapTx: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/misc/EquitySwapTx.ds', data, config, success)
    },
    approveEquitySwapTx: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/misc/ApproveEquitySwapTx.ds', data, config, success)
    },

    getEquitySwapTxList: function (params, success) {
        $http.get('/i/fang/misc/EquitySwapTx.List.ds', {params}, success)
    },
    getEquitySwapTx: function (params, success) {
        $http.get('/i/fang/misc/EquitySwapTx.ds', {params}, success)
    },

    getRepaymentFangList: function (params, success) {
        $http.get('/i/fang/financing/lender/Repayment.List.ds', {params}, success)
    },

    UpdateRepayWithExcessAmountInBatch:function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/execute/fang/repayment/RepayWithExcessAmountInBatch.ds', data, config, success )
    },
    getFinancingFangSelect :function (params, success) {
        $http.get('/i/fang/misc/Financing.Select.ds', {params}, success)
    },
    saveSealApplicationForApproval: function (data,success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/misc/SealApplicationForApproval.ds', data, config, success )
    },
    getSealApplicationList: function (params, success) {
        $http.get('/i/fang/misc/SealApplication.List.ds', {params}, success)
    },
    getViewSealApplication: function (params, success) {
        $http.get('/i/fang/misc/ViewSealApplication.ds', {params}, success)
    },

    withdrawSealApplication: function (data,success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/execute/fang/misc/WithdrawSealApplication.ds', data, config, success )
    },

    ApproveSealApplication: function (data,success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/misc/ApproveSealApplication.ds', data, config, success )
    },
    getEquitySwapTxSelect :function (params, success) {
        $http.get('/i/fang/misc/EquitySwapTx.Select.ds', {params}, success)
    },
    getAllocationSelect :function (params, success) {
        $http.get('/i/fang/misc/Allocation.Select.ds', {params}, success)
    },
    getPayee :function (params, success) {
        $http.get('/i/fang/misc/AllPayee.Select.ds', {params}, success)
    },


    //分公司
    getBranchOfficeList: function (params, success) {
        $http.get('/i/fang/branch/BranchOffice.List.ds', {params}, success)
    },

    updateBranchOffice: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/branch/BranchOffice.ds', data, config, success)
    },
    deleteBranchOffice: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/branch/DeleteBranchOffice.ds', data, config, success)
    },
    getBranchOffice: function (params, success) {
        $http.get('/i/fang/branch/BranchOffice.ds', {params}, success)
    },
    //面签室
    getDataRoomList: function (params, success) {
        $http.get('/i/fang/branch/BranchSigningRoom.List.ds', {params}, success)
    },
    getDataRoom: function (params, success) {
        $http.get('/i/fang/branch/BranchSigningRoom.ds', {params}, success)
    },
   //新增面签室
    updateBranchSigningRoom: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/branch/BranchSigningRoom.ds', data, config, success)
    },

    deleteBranchSigningRoom: function (data, success) {
    let config = {
        showMessage: true
    }
    $http.post('/i/update/fang/branch/DeleteBranchSigningRoom.ds', data, config, success)
},

    //办押点
    getDataLocationList: function (params, success) {
        $http.get('/i/fang/branch/BranchPledgeLocation.List.ds', {params}, success)
    },
    getDataLocation: function (params, success) {
        $http.get('/i/fang/branch/BranchPledgeLocation.ds', {params}, success)
    },
    //新增办押点
    updateBranchPledgeLocation: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/branch/BranchPledgeLocation.ds', data, config, success)
    },
    deleteBranchPledgeLocation: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/branch/DeleteBranchPledgeLocation.ds', data, config, success)
    },

    //分公司用户
    getDataBranchUserList: function (params, success) {
        $http.get('/i/fang/branch/BranchUser.List.ds', {params}, success)
    },

    deleteBranchUser: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/branch/DeleteBranchUser.ds', data, config, success)
    },
    getDataBranchOfficeSelect: function (params, success) {
        $http.get('/i/fang/branch/BranchOffice.Select.ds', {params}, success)
    },
    getBranchUser: function (params, success) {
        $http.get('/i/fang/branch/BranchUser.ds', {params}, success)
    },
    updateBranchUser: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/branch/BranchUser.ds', data, config, success)
    },
    resetBranchUserPassword: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/branch/ResetBranchUserPassword.ds', data, config, success)
    },



    //分公司指派
    getDataBranchAllocationList: function (params, success) {
        $http.get('/i/fang/financing/BranchAllocation.List.ds', {params}, success)
    },

    updateAllocateBranch: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/financing/AllocateBranch.ds', data, config, success)
    },
//盖章
    JxSign1: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/bestsign/JxSign1.ds', data, config, success)
    },

    JxSign2: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/bestsign/JxSign2.ds', data, config, success)
    },


    VoidBranchAllocation: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/financing/VoidBranchAllocation.ds', data, config, success)
    },

    //待审核预约
    getBranchAppointmentList: function (params, success) {
        $http.get('/i/fang/financing/BranchAppointment.List.ds', {params}, success)
    },
    getBranchAppointment: function (params, success) {
    $http.get('/i/fang/financing/ViewBranchAppointment.ds', {params}, success)
    },
    updateApproveBranchAppointment: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/financing/ApproveBranchAppointment.ds', data, config, success)
    },
    rejectBranchAppointment: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/financing/RejectBranchAppointment.ds', data, config, success)
    },

    getViewSigningTx: function (params, success) {
        $http.get('/i/fang/financing/ViewSigningTx.ds', {params}, success)
    },


    //外勤任务
    getBranchAssignmentList: function (params, success) {
        $http.get('/i/fang/financing/BranchAssignment.List.ds', {params}, success)
    },
    getDataBranchUserSelect: function (params, success) {
        $http.get('/i/fang/branch/BranchUser.Select.ds', {params}, success)
    },
    getBranchAssignment: function (params, success) {
        $http.get('/i/fang/financing/BranchAssignment.ds', {params}, success)
    },
    updateBranchAssignment: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/financing/BranchAssignment.ds', data, config, success)
    },

    //通知
    getBranchNoticeList: function (params, success) {
        $http.get('/i/fang/financing/BranchNotice.List.ds', {params}, success)
    },
    getBranchNotice: function (params, success) {
        $http.get('/i/fang/financing/BranchNotice.ds', {params}, success)
    },
    updateBranchNotice: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/financing/BranchNotice.ds', data, config, success)
    },
    deleteBranchNotice: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/financing/DeleteBranchNotice.ds', data, config, success)
    },
    //留言
    getBranchMessageList: function (params, success) {
        $http.get('/i/fang/financing/BranchMessage.List.ds', {params}, success)
    },
    getBranchMessage: function (params, success) {
        $http.get('/i/fang/financing/ViewBranchMessage.ds', {params}, success)
    },
    replyBranchMessage: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/financing/ReplyBranchMessage.ds', data, config, success)
    },

    createBranchMessage: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/financing/CreateBranchMessage.ds', data, config, success)
    },
    deleteBranchMessage: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/financing/DeleteBranchMessage.ds', data, config, success)
    },
    //以下为大屏使用接口
    /**
     * 拿大屏统计变量数据
     * @param success
     */
    getDashboardVariables: function (success) {
        const params = {
            pageSize: 0
        }
        $http.get('/i/fang/dashboard/Dashboard.List.ds', {params}, success)
    },
    /**
     * 拿全部小区
     * @param params
     * @param success
     */
    getFinancingByPropertyLocationList: function (params = {pageSize: 0}, success) {
        const config = {
            params,
            showLoading:false
        }
        $http.get('/i/fang/dashboard/FinancingByPropertyLocation.List.ds', config, success)
    },
    /**
     * 指定小区 参数 locationName
     * @param locationName
     * @param success
     */
    getFinancingByPropertyLocationIIList: function (locationName = '', success) {
        const params = {
            locationName
        }
        $http.get('/i/fang/dashboard/FinancingByPropertyLocationII.List.ds', {params}, success)
    },
    /**
     * 指定小区 参数 locationName
     * @param locationName
     * @param success
     */
    getFinancingByPropertyLocationIIIList: function (locationName = '', success) {
        const params = {
            locationName
        }
        $http.get('/i/fang/dashboard/FinancingByPropertyLocationIII.List.ds', {params}, success)
    },
    /**
     * 指定小区 参数 locationName
     * @param locationName
     * @param success
     */
    getFinancingByPropertyLocationIVList: function (locationName = '', success) {
        const params = {
            locationName
        }
        $http.get('/i/fang/dashboard/FinancingByPropertyLocationIV.List.ds', {params}, success)
    },
    /**
     * 行政区统计数据
     * @param pageSize
     * @param success
     */
    getFinancingByPropertyLocationVList: function (pageSize = 0, success) {
        const params = {
            pageSize
        }
        $http.get('/i/fang/dashboard/FinancingByPropertyLocationV.List.ds', {params}, success)
    },
    /**
     * 拿行业列表数据
     * @param pageSize
     * @param success
     */
    getFinancingByIndustryList: function (pageSize = 0, success) {
        const params = {
            pageSize
        }
        $http.get('/i/fang/dashboard/FinancingByIndustry.List.ds', {params}, success)
    },
    /**
     * 拿抵押等级列表数据
     * @param pageSize
     * @param success
     */
    getFinancingByPledgeGradeList: function (pageSize = 0, success) {
        const params = {
            pageSize
        }
        $http.get('/i/fang/dashboard/FinancingByPledgeGrade.List.ds', {params}, success)
    },
    /**
     * 拿婚姻统计数据
     * @param pageSize
     * @param success
     */
    getFinancingByMartialStatusList: function (pageSize= 0, success) {
        const params = {
            pageSize
        }

        $http.get('/i/fang/dashboard/FinancingByMartialStatus.List.ds', {params}, success)
    },
    /**
     * 拿房屋性质统计数据
     * @param pageSize
     * @param success
     */
    getFinancingByPropertyUsageList: function (pageSize= 0, success) {
        const params = {
            pageSize
        }

        $http.get('/i/fang/dashboard/FinancingByPropertyUsage.List.ds', {params}, success)
    },
    /**
     * 拿最近6个月的统计数据
     * @param pageSize
     * @param success
     */
    getFinancingLast6MonthsList: function (pageSize= 0, success) {
        const params = {
            pageSize
        }

        $http.get('/i/fang/dashboard/FinancingLast6Months.List.ds', {params}, success)
    },
    /**
     * 拿最新大屏事件
     * @param pageSize
     * @param success
     */
    getMonitorEventList: function (pageSize= 0, success) {
        const params = {
            pageSize
        }
        const config = {
            params,
            showLoading:false
        }

        $http.get('/i/fang/dashboard/Event.List.ds', config, success)
    },
    /**
     * 查询可延期的贷款
     * @param params
     * @param success
     */
    getFangFinancingForExtendingList :function (params, success) {
        $http.get('/i/fang/financing/FinancingForExtending.List.ds', {params}, success)
    },
    /**
     * 查询和计算还款计划供页面展示
     * @param params
     * @param success
     */
    getFangFinancingForExtending :function (params, success) {
        $http.get('/i/fang/financing/ExtendFinancing.ds', {params}, success)
    },
    /**
     * 确认延期
     * @param data
     * @param success
     */
    extendFinancing :function (data, success) {
        $http.post('/i/execute/fang/financing/ExtendFinancing.ds', data, {}, success)
    },


        /**
         *
         */
    getApprovingApplyingCustomerApp: function (params, success) {
        $http.get('/i/fang/dashboard/ApprovingApplyingCustomer.List.ds', {params}, success)
    },
    /**
     *
     */
    getApprovingFinancingApp: function (params, success) {
        $http.get('/i/fang/dashboard/ApprovingFinancing.List.ds', {params}, success)
    },
    /**
     *
     */
    getApprovingFinancingPaymentApp: function (params, success) {
        $http.get('/i/fang/dashboard/ApprovingFinancingPayment.List.ds', {params}, success)
    },
    /**
     *
     */
    getApprovingSealApplicationApp: function (params, success) {
        $http.get('/i/fang/dashboard/ApprovingSealApplication.List.ds', {params}, success)
    },
    /**
     *
     */
    getApprovingRepaymentInAdvanceApp: function (params, success) {
        $http.get('/i/fang/dashboard/ApprovingRepaymentInAdvance.List.ds', {params}, success)
    },
    /**
     *
     */
    getApprovingHisWarrantTxApp: function (params, success) {
        $http.get('/i/fang/dashboard/ApprovingHisWarrantTx.List.ds', {params}, success)
    },
    /**
     *
     */
    getApprovingRepaymentApp: function (params, success) {
        $http.get('/i/fang/dashboard/ApprovingRepayment.List.ds', {params}, success)
    },

    updateFaihai: function (data, success) {
        let config = {
            showMessage: true
        }
        $http.post('/i/update/fang/misc/FahaiQuery.ds', data, config, success)
    },
    getFaihaiList: function (params, success) {
        $http.get('/i/fang/misc/FahaiQuery.List.ds', {params}, success)
    },
    getFaihaiView: function (params, success) {
        $http.get('/i/fang/misc/FahaiQuery.ds', {params}, success)
    },
}


export default api

window.$http = $http    //注册到全局方法，用来控制台调试使用



// WEBPACK FOOTER //
// ./src/utils/xhr.js